import React, { useState, useEffect, useRef } from 'react';
import { properties } from '../properties';
import apiFetch from '../auth/apiFetch';

import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getInstructors, getDojosNames, getGrades, getStates, postData } from './HTTPService';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { TabView, TabPanel } from 'primereact/tabview';

import 'primereact/resources/themes/nova/theme.css'
//import 'primereact/resources/themes/bootstrap4-light-blue/theme.css'
//import 'primereact/resources/themes/md-light-indigo/theme.css'
//import 'primereact/resources/themes/tailwind-light/theme.css'
//import 'primereact/resources/themes/fluent-light/theme.css'
//import 'primereact/resources/themes/saga-green/theme.css'
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Fieldset } from 'primereact/fieldset';
import { useTranslation } from "react-i18next";
import { isValidE164, formatPhoneForDisplay } from '../utils/phone';
//import { joinPaths } from 'react-router/lib/router';

function Instructors() {

    let emptyAffiliate = {
        id: '',
        name: '',
        cpf: '',
        rg: '',
        birthDate: '',
        date: '',
        jkaRegister: '',
        jkaId: '',
        jkaJpRecord: '',
        passport: '',
        jkaJpId: '',
        state: {
            id: '',
            name: '',
        },
        status: false,
        active: false,
        affiliate: false,
        affiliateAddress: {
            addressComplement: '',
            city: '',
            neighborhood: '',
            state: '',
            street: '',
            streetNumber: '',
            zipCode: '',
        },
        contacts: {
            email1: '',
            email2: '',
            mobile1: '',
            mobile2: '',
            phone1: '',
            phone2: '',
        },
        gym: {
            id: '',
            name: '',
        },
        grade: {
            id: '',
            belt: '',
            level: '',
        },
        genericGrade: '',
        socialMedia: {
            facebookId: '',
            instagramId: '',
            site: '',
            twitterId: '',
        },
        note: '',
        occupation: '',
        affiliateAnnuities: [],
        judgeLicenses: [],
        instructorLicenses: [],
        examinerLicenses: [],
        danExams: []
    };

    useEffect(() => {
        getDojosNames().then(data => setDojos(data));
        getInstructors().then(data => setAffiliates(data));
        getStates().then(data => setStates(data));
        getGrades().then(data => setGrades(data));

    }, []);

    const [activeIndex, setActiveIndex] = useState(0);

    const statusPayment = [
        { name: 'Pendente', value: false },
        { name: 'Paga', value: true },
    ];

    const statusActive = [
        { name: 'Inativo', value: false },
        { name: 'Ativo', value: true },
    ];

    const [licenseId, setLicenseId] = useState('');
    const [licenseClass, setLicenseClass] = useState('');
    const [licenseRegistrationId, setLicenseRegistrationId] = useState('');
    const [licenseAquisitionYear, setLicenseAquisitionYear] = useState('');
    const [licenseValid, setLicenseValid] = useState('');



    const [genericGrade, setGenericGrade] = useState('');
    const [danExamId, setDanExamId] = useState('');
    const [danExamDanId, setDanExamDanId] = useState('');
    const [danExamRecordDate, setDanExamRecordDate] = useState('');
    const [danExamRecord, setDanExamRecord] = useState('');


    const [annuityYear, setAnnuityYear] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [value, setValue] = useState('');
    const [jkabrCardDate, setJkabrCardDate] = useState('');

    const [annuityId, setAnnuityId] = useState('');

    const { t } = useTranslation();
    const [selectedState, setSelectedState] = useState(null);

    const [states, setStates] = useState(null);

    const [dojos, setDojos] = useState(null);
    const [grades, setGrades] = useState(null);
    const [selectedPaid, setSelectedPaid] = useState(false);
    const [selectedActive, setSelectedActive] = useState(false);
    const [affiliates, setAffiliates] = useState(null);
    const [selectedGrade, setSelectedGrade] = useState(null);
    const [affiliateDialog, setAffiliateDialog] = useState(false);
    const [deleteAffiliateDialog, setDeleteAffiliateDialog] = useState(false);
    const [deleteJudgeLicenseDialog, setDeleteJudgeLicenseDialog] = useState(false);
    const [deleteInstructorLicenseDialog, setDeleteInstructorLicenseDialog] = useState(false);
    const [deleteExaminerLicenseDialog, setDeleteExaminerLicenseDialog] = useState(false);
    const [instructorLicenseDialog, setInstructorLicenseDialog] = useState(false);
    const [editInstructorLicenseDialog, setEditInstructorLicenseDialog] = useState(false);

    const [examinerLicenseDialog, setExaminerLicenseDialog] = useState(false);
    const [editExaminerLicenseDialog, setEditExaminerLicenseDialog] = useState(false);
    const [annuityDialog, setAnnuityDialog] = useState(false);
    const [editAnnuityDialog, setEditAnnuityDialog] = useState(false);
    const [deleteAnnuityDialog, setDeleteAnnuityDialog] = useState(false);


    const [danExamDialog, setDanExamDialog] = useState(false);
    const [deleteDanExamDialog, setDeleteDanExamDialog] = useState(false);
    const [editDanExamDialog, setEditDanExamDialog] = useState(false);


    const [judgeLicenseDialog, setJudgeLicenseDialog] = useState(false);
    const [editJudgeLicenseDialog, setEditJudgeLicenseDialog] = useState(false);
    const [deleteAffiliatesDialog, setDeleteAffiliatesDialog] = useState(false);
    const [idToDelete, setIdToDelete] = useState(0);
    const [affiliate, setAffiliate] = useState(emptyAffiliate);
    const [selectedAffiliates, setSelectedAffiliates] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loadingEdit, setLoadingEdit] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const [selectedDojo, setSelectedDojo] = useState(null);

    const onDojoChange = (e) => {
        setSelectedDojo(e.value);
        let _affiliate = { ...affiliate };
        _affiliate['gym'] = e.value;
        setAffiliate(_affiliate);
    }
    const onStateChange = (e) => {
        setSelectedState(e.value);
        let _affiliate = { ...affiliate };
        _affiliate.state = e.value;
        setAffiliate(_affiliate);
    }

    const onPaidChange = (e) => {
        setSelectedPaid(e.value);
        let _affiliate = { ...affiliate };
        _affiliate['status'] = e.value;
        setAffiliate(_affiliate);
    }

    const onActiveChange = (e) => {
        setSelectedActive(e.value);
        let _affiliate = { ...affiliate };
        _affiliate['active'] = e.value;
        setAffiliate(_affiliate);
    }

    const handleChange = (e) => {
        setSelectedGrade(e.value);
        let _affiliate = { ...affiliate };
        _affiliate['grade'] = e.value;
        setAffiliate(_affiliate);
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    const openNew = () => {
        setAffiliate(emptyAffiliate);
        setSubmitted(false);
        setAffiliateDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setAffiliateDialog(false);
    }

    const showJudgeLicenseDialog = () => {
        clearLicenseData();
        setJudgeLicenseDialog(true);

    }

    const hideJudgeLicenseDialog = () => {
        clearLicenseData();
        setJudgeLicenseDialog(false);
    }



    const hideAnnuityDialog = () => {
        clearAnnuityData();
        setAnnuityDialog(false);
    }

    const hideEditAnnuityDialog = () => {
        clearAnnuityData();
        setEditAnnuityDialog(false);
    }



    const showEditJudgeLicenseDialog = () => {
        //   setLicenseClass(affiliate.judgeLicense.licenseClass);
        //   setLicenseRegistrationId('');
        //   setLicenseAquisitionYear('');
        //   setLicenseValid('');

        setEditJudgeLicenseDialog(true);
    }


    const showDanExamDialog = () => {
        clearDanExamData();
        setDanExamDialog(true);
    }


    const showInstructorLicenseDialog = () => {
        clearLicenseData();
        setInstructorLicenseDialog(true);
    }

    const showAnnuityDialog = () => {
        clearAnnuityData();
        setAnnuityDialog(true);
    }

    const hideInstructorLicenseDialog = () => {
        setInstructorLicenseDialog(false);
    }

    const showExaminerLicenseDialog = () => {
        clearLicenseData();
        setExaminerLicenseDialog(true);
    }

    const hideExaminerLicenseDialog = () => {
        setExaminerLicenseDialog(false);
    }

    const shoDanExamDialog = () => {
        clearLicenseData();
        setDanExamDialog(true);
    }

    const hideDanExamDialog = () => {
        setDanExamDialog(false);
    }

    const hideDeleteAffiliateDialog = () => {
        setDeleteAffiliateDialog(false);
    }

    const hideDeleteAffiliatesDialog = () => {
        setDeleteAffiliatesDialog(false);
    }

    const hideDeleteJudgeLicenseDialog = () => {
        setDeleteJudgeLicenseDialog(false);
    }


    const hideDeleteDanExamDialog = () => {
        setDeleteDanExamDialog(false);
    }

    const hideDeleteInstructorLicenseDialog = () => {
        setDeleteInstructorLicenseDialog(false);
    }

    const hideDeleteExaminerLicenseDialog = () => {
        setDeleteExaminerLicenseDialog(false);
    }

    const hideDeleteDanExamLicenseDialog = () => {
        setDeleteDanExamDialog(false);
    }

    const hideDeleteAnnuityDialog = () => {
        setDeleteAnnuityDialog(false);
    }



    const hideEditJudgeLicenseDialog = () => {
        clearLicenseData();
        setEditJudgeLicenseDialog(false);
    }


    const saveAffiliate = () => {
        setSubmitted(true);

        if (affiliate.name.trim()) {
            let _affiliates = [...affiliates];
            affiliate.gym.id = selectedDojo.id;
            affiliate.grade.id = selectedGrade.id;
            let _affiliate = { ...affiliate };
            if (affiliate.id) {
                const index = findIndexById(affiliate.id);
                _affiliates[index] = _affiliate;
                putData(_affiliate)
                toast.current.show({ severity: 'success', summary: t('msg.jkaSuccessful'), detail: t('msg.jkaAffiliateUpdated'), life: 3000 });
            }
            else {
                _affiliate.id = 0;
                _affiliate.image = 'product-placeholder.svg';
                _affiliates.push(_affiliate);
                postData(_affiliate)
                toast.current.show({ severity: 'success', summary: t('msg.jkaSuccessful'), detail: t('msg.jkaAffiliateCreated'), life: 3000 });
            }

            setAffiliates(_affiliates);
            setAffiliateDialog(false);
            setAffiliate(emptyAffiliate);
        }
    }

    const editAffiliate = async (rowData) => {
        setLoadingEdit(true);
        try {
            const res = await apiFetch(properties.baseURL + properties.affiliatesPath + '/' + rowData.id);
            if (!res.ok) throw new Error(`Erro ${res.status}`);
            const detail = await res.json();
            setAffiliate({ ...detail });
            setSelectedDojo({ "id": detail.gym.id, "name": detail.gym.name });
            setSelectedGrade({ "id": detail.grade.id, "level": detail.grade.level, "belt": detail.grade.belt });
            setSelectedState({ "id": detail.state.id, "name": detail.state.name });
            setSelectedPaid(detail.status);
            setSelectedActive(detail.active);
            setAffiliateDialog(true);
        } catch (err) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Não foi possível carregar os dados do associado.',
                life: 4000,
            });
        } finally {
            setLoadingEdit(false);
        }
    }

    const confirmDeleteAffiliate = (affiliate) => {
        setAffiliate(affiliate);
        setDeleteAffiliateDialog(true);
    }

    const deleteAffiliate = () => {
        let _affiliates = affiliates.filter(val => val.id !== affiliate.id);
        setAffiliates(_affiliates);
        delAffiliates(affiliate.id)
        setDeleteAffiliateDialog(false);
        setAffiliate(emptyAffiliate);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: "Associado " + affiliate.name + ' deletado', life: 3000 });
    }


    const confirmDeleteAnnuity = (annuity) => {
        setIdToDelete(annuity.id);
        setDeleteAnnuityDialog(true);
    }

    const updateAnnuity = () => {
        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.affiliateAnnuities.findIndex((obj => obj.id === annuityId));
        _affiliate.affiliateAnnuities[upd_obj].value = value;
        _affiliate.affiliateAnnuities[upd_obj].year = annuityYear;
        _affiliate.affiliateAnnuities[upd_obj].paymentDate = paymentDate;
        _affiliate.affiliateAnnuities[upd_obj].jkabrCardDate = jkabrCardDate;
        setAffiliate(_affiliate);
        hideEditAnnuityDialog(true);
    }

    const editAnnuity = (annuity) => {
        setAnnuityId(annuity.id)
        setAnnuityYear(annuity.year)
        setPaymentDate(annuity.paymentDate)
        setValue(annuity.value)
        setJkabrCardDate(annuity.jkabrCardDate);
        setEditAnnuityDialog(true);
    }

    const editInstructorLicense = (license) => {
        setLicenseId(license.id);
        setLicenseClass(license.classe);
        setLicenseRegistrationId(license.registrationId);
        setLicenseAquisitionYear(license.aquisitionYear);
        setLicenseValid(license.valid);
        setEditInstructorLicenseDialog(true);
    }

    const updateInstructorLicense = () => {
        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.instructorLicenses.findIndex((obj => obj.id === licenseId));
        _affiliate.instructorLicenses[upd_obj].classe = licenseClass;
        _affiliate.instructorLicenses[upd_obj].registrationId = licenseRegistrationId;
        _affiliate.instructorLicenses[upd_obj].aquisitionYear = licenseAquisitionYear;
        _affiliate.instructorLicenses[upd_obj].valid = licenseValid;
        setAffiliate(_affiliate);
        clearLicenseData();
        hideEditInstructorLicenseDialog(true);
    }

    const editExaminerLicense = (license) => {
        setLicenseId(license.id);
        setLicenseClass(license.classe);
        setLicenseRegistrationId(license.registrationId);
        setLicenseAquisitionYear(license.aquisitionYear);
        setLicenseValid(license.valid);
        setEditExaminerLicenseDialog(true);
    }


    const updateExaminerLicense = () => {
        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.examinerLicenses.findIndex((obj => obj.id === licenseId));
        _affiliate.examinerLicenses[upd_obj].classe = licenseClass;
        _affiliate.examinerLicenses[upd_obj].registrationId = licenseRegistrationId;
        _affiliate.examinerLicenses[upd_obj].aquisitionYear = licenseAquisitionYear;
        _affiliate.examinerLicenses[upd_obj].valid = licenseValid;
        setAffiliate(_affiliate);
        clearLicenseData();
        hideEditExaminerLicenseDialog(true);
    }

    const updateDanExam = () => {
        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.danExams.findIndex((obj => obj.id === danExamId));

        _affiliate.danExams[upd_obj].date = danExamRecordDate;
        _affiliate.danExams[upd_obj].danId = danExamDanId;
        _affiliate.danExams[upd_obj].record = danExamRecord;
        setAffiliate(_affiliate);
        clearDanExamData();
        hideEditDanExamDialog(true);
    }

    const editDanExam = (danExam) => {
        setDanExamId(danExam.id);
        setDanExamDanId(danExam.danId);
        setDanExamRecordDate(danExam.date);
        setDanExamRecord(danExam.record);
        setEditDanExamDialog(true);
    }

    const editJudgeLicense = (license) => {
        setLicenseId(license.id);
        setLicenseClass(license.classe);
        setLicenseRegistrationId(license.registrationId);
        setLicenseAquisitionYear(license.aquisitionYear);
        setLicenseValid(license.valid);
        setEditJudgeLicenseDialog(true);
    }

    const updateJudgeLicense = () => {
        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.judgeLicenses.findIndex((obj => obj.id === licenseId));
        _affiliate.judgeLicenses[upd_obj].classe = licenseClass;
        _affiliate.judgeLicenses[upd_obj].registrationId = licenseRegistrationId;
        _affiliate.judgeLicenses[upd_obj].aquisitionDate = licenseAquisitionYear;
        _affiliate.judgeLicenses[upd_obj].validDate = licenseValid;
        setAffiliate(_affiliate);
        clearLicenseData();
        hideEditJudgeLicenseDialog(true);
    }

    const delAffiliates = (id) => {
        apiFetch(properties.baseURL + properties.affiliatesPath + `/${id}`, { method: 'DELETE' })
            //     .then(() => this.setState({ status: 'Delete successful' }));
            .then(() => alert("call delete $id"));
    }

    const deleteInstructorLicense = () => {

        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.instructorLicenses.findIndex((obj => obj.id === idToDelete));
        delete _affiliate.instructorLicenses[upd_obj];
        setAffiliate(_affiliate);

        apiFetch(properties.baseURL + properties.instructorlicensesPath + `/${idToDelete}`, { method: 'DELETE' })
            .then((response) => {
                if (response.status === 200) {
                    console.log("SUCCESSS")
                    removeById(affiliate.instructorLicenses, idToDelete);
                } else if (response.status === 408) {
                    console.log("SOMETHING WENT WRONG")
                    this.setState({ requestFailed: true })
                }
            })
        setIdToDelete(0);
        setDeleteInstructorLicenseDialog(false);
    }

    const confirmDeleteInstructorLicense = (instructorLicense) => {
        setIdToDelete(instructorLicense.id);
        setDeleteInstructorLicenseDialog(true);
    }



    const deleteJudgeLicense = () => {

        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.judgeLicenses.findIndex((obj => obj.id === idToDelete));
        delete _affiliate.judgeLicenses[upd_obj];
        setAffiliate(_affiliate);

        apiFetch(properties.baseURL + properties.judgelicensesPath + `/${idToDelete}`, { method: 'DELETE' })
            .then((response) => {
                if (response.status === 200) {
                    console.log("SUCCESSS")
                    removeById(affiliate.judgeLicenses, idToDelete);
                } else if (response.status === 408) {
                    console.log("SOMETHING WENT WRONG")
                    this.setState({ requestFailed: true })
                }
            })
        setIdToDelete(0);
        setDeleteJudgeLicenseDialog(false);
    }

    const confirmDeleteExaminerLicense = (examinerLicense) => {
        setIdToDelete(examinerLicense.id);
        setDeleteExaminerLicenseDialog(true);
    }

    const confirmDeleteDanExam = (danExam) => {
        setIdToDelete(danExam.id);
        setDeleteDanExamDialog(true);
    }


    const deleteDanExam = () => {

        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.danExams.findIndex((obj => obj.id === idToDelete));
        let level = upd_obj + " DAN";
        setSelectedGrade({ "id": upd_obj, "level": level, "belt": 'Faixa Preta' });
        _affiliate.genericGrade = level;
        delete _affiliate.danExams[upd_obj];
        setAffiliate(_affiliate);
        apiFetch(properties.baseURL + properties.danExamsPath + `/${idToDelete}`, { method: 'DELETE' })
            .then((response) => {
                if (response.status === 200) {
                    console.log("SUCCESSS")
                    //dando erro
                    //   removeById(affiliate.danExams, idToDelete);
                } else if (response.status === 408) {
                    console.log("SOMETHING WENT WRONG")
                    this.setState({ requestFailed: true })
                }
            })

        setIdToDelete(0);

        setDeleteDanExamDialog(false);

    }


    const deleteExaminerLicense = () => {

        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.examinerLicenses.findIndex((obj => obj.id === idToDelete));
        delete _affiliate.examinerLicenses[upd_obj];
        setAffiliate(_affiliate);

        apiFetch(properties.baseURL + properties.examinerlicensesPath + `/${idToDelete}`, { method: 'DELETE' })
            .then((response) => {
                if (response.status === 200) {
                    console.log("SUCCESSS")
                    removeById(affiliate.examinerLicenses, idToDelete);
                } else if (response.status === 408) {
                    console.log("SOMETHING WENT WRONG")
                    this.setState({ requestFailed: true })
                }
            })
        setIdToDelete(0);
        setDeleteExaminerLicenseDialog(false);
    }

    const deleteAnnuity = () => {

        let _affiliate = { ...affiliate };
        let upd_obj = _affiliate.affiliateAnnuities.findIndex((obj => obj.id === idToDelete));
        delete _affiliate.affiliateAnnuities[upd_obj];
        setAffiliate(_affiliate);
        apiFetch(properties.baseURL + properties.affiliateAnnuitiesPath + `/${idToDelete}`, { method: 'DELETE' })
            .then((response) => {
                if (response.status === 200) {
                    console.log("SUCCESSS")
                    removeById(affiliate.affiliateAnnuities, idToDelete);
                } else if (response.status === 408) {
                    console.log("SOMETHING WENT WRONG")
                    this.setState({ requestFailed: true })
                }
            })
        setIdToDelete(0);
        setDeleteAnnuityDialog(false);
    }

    const confirmDeleteJudgeLicense = (judgeLicense) => {
        setIdToDelete(judgeLicense.id);
        setDeleteJudgeLicenseDialog(true);
    }


    const removeById = (arr, id) => {
        const requiredIndex = arr.findIndex(el => {
            // return el.id === String(id);
            return el.id === id;
        });
        if (requiredIndex === -1) {
            return false;
        };
        return !!arr.splice(requiredIndex, 1);
    };



    async function putData(affiliate) {
        try {
            const res = await apiFetch(properties.baseURL + properties.affiliatesPath + "/" + affiliate.id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(affiliate),
            });
            if (!res.ok) {
                const message = `An error has occured: ${res.status} - ${res.statusText}`;
                throw new Error(message);
            }
            const data = await res.json();
            const result = {
                status: res.status + "-" + res.statusText,
                headers: {
                    "Content-Type": res.headers.get("Content-Type"),
                    "Content-Length": res.headers.get("Content-Length"),
                },
                data: data,
            };
            console.log(result);
        } catch (err) {
            console.log(err.message);
        }
    }

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < affiliates.length; i++) {
            if (affiliates[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const confirmDeleteSelected = () => {
        setDeleteAffiliateDialog(true);
    }

    const deleteSelectedAffiliates = () => {
        let _affiliates = affiliates.filter(val => !selectedAffiliates.includes(val));
        setAffiliates(_affiliates);
        setDeleteAffiliatesDialog(false);
        setSelectedAffiliates(null);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Associado deletado', life: 3000 });
    }

    const setStreetNumber = (e) => {
        affiliate.affiliateAddress.streetNumber = e;
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _affiliate = { ...affiliate };
        if (name.includes('.')) {
            let fields = name.split('.');
            let first = fields[0];
            let second = fields[1];
            _affiliate[`${first}`][`${second}`] = val;
        }
        else {
            _affiliate[`${name}`] = val;
        }
        setAffiliate(_affiliate);
    }

    const phoneBodyTemplate = (value) => {
        if (!value) return '';
        if (isValidE164(value)) return formatPhoneForDisplay(value);
        return <span>{value} <i className="pi pi-exclamation-triangle" style={{ color: '#f59e0b' }} title="Telefone não validado" /></span>;
    };

    const statusBodyTemplate = (rowData) => {
        if (rowData.status) {
            return <span className={'customer-badge status-qualified'}>{t('msg.jkaPaidAnnuity')}</span>;
        }
        else {
            return <span className={'customer-badge status-unqualified'}>{t('msg.jkaUnpaidAnnuity')}</span>;
        }
    }

    const activeBodyTemplate = (rowData) => {
        if (rowData.active) {
            return <span className={'customer-badge status-qualified'}>{t('msg.jkaActive')}</span>;
        }
        else {
            return <span className={'customer-badge status-unqualified'}>{t('msg.jkaInactive')}</span>;
        }
    }

   

    const actionDanExamBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editDanExam(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDeleteDanExam(rowData)} />
            </React.Fragment>
        );
    }

    const actionJudgeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editJudgeLicense(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDeleteJudgeLicense(rowData)} />
            </React.Fragment>
        );
    }

    const actionInstructorBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editInstructorLicense(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDeleteInstructorLicense(rowData)} />
            </React.Fragment>
        );
    }

    const actionExaminerBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editExaminerLicense(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDeleteExaminerLicense(rowData)} />
            </React.Fragment>
        );
    }

    const actionAnnuityBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editAnnuity(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDeleteAnnuity(rowData)} />
            </React.Fragment>
        );
    }



    const header = (
        <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
            <span className="p-input-icon-left w-full md:w-auto">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="w-full lg:w-auto" />
            </span>
            <div className="mt-3 md:mt-0 flex justify-content-end">
                <Button icon="pi pi-plus" className="mr-2 p-button-rounded" onClick={openNew} tooltip="New" tooltipOptions={{ position: 'bottom' }} />
                <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-rounded" onClick={confirmDeleteSelected} disabled={!selectedAffiliates || !selectedAffiliates.length} tooltip="Delete" tooltipOptions={{ position: 'bottom' }} />
                <Button icon="pi pi-upload" className="p-button-help p-button-rounded" onClick={exportCSV} tooltip="Export" tooltipOptions={{ position: 'bottom' }} />
            </div>
        </div>
    );

    const affiliateDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" onClick={saveAffiliate} />
        </React.Fragment>
    );

    const deleteAffiliateDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteAffiliateDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteAffiliate} />
        </React.Fragment>
    );

    const deleteAffiliatesDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteAffiliatesDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedAffiliates} />
        </React.Fragment>
    );

    const deleteDanExamDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDanExamDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteDanExam} />
        </React.Fragment>
    );

    const deleteJudgeLicenseDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteJudgeLicenseDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteJudgeLicense} />
        </React.Fragment>
    );

    const deleteInstructorLicenseDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteInstructorLicenseDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteInstructorLicense} />
        </React.Fragment>
    );

    const deleteExaminerLicenseDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteExaminerLicenseDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteExaminerLicense} />
        </React.Fragment>
    );

    const deleteAnnuityDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteAnnuityDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteAnnuity} />
        </React.Fragment>
    );

    const hideInsertDanExamDialog = () => {
        clearDanExamData();
        setDanExamDialog(false);
    }




    const hideInsertJudgeLicenseDialog = () => {
        clearLicenseData();
        setJudgeLicenseDialog(false);
    }

    const hideInsertExaminerLicenseDialog = () => {
        clearLicenseData();
        setExaminerLicenseDialog(false);
    }

    const hideInsertAnnuityDialog = () => {
        clearAnnuityData();
        setAnnuityDialog(false);
    }


    const hideInsertInstructorLicenseDialog = () => {
        clearLicenseData();
        setInstructorLicenseDialog(false);
    }

    const hideEditInstructorLicenseDialog = () => {
        clearLicenseData();
        setEditInstructorLicenseDialog(false);
    }

    const hideEditExaminerLicenseDialog = () => {
        clearLicenseData();
        setEditExaminerLicenseDialog(false);
    }

    const hideEditDanExamDialog = () => {
        clearLicenseData();
        setEditDanExamDialog(false);
    }

    function clearDanExamData() {
        setDanExamId('');
        setDanExamDanId('');
        setDanExamRecordDate('');
        setDanExamRecord('');

    }



    function clearLicenseData() {
        setLicenseClass('');
        setLicenseRegistrationId('');
        setLicenseAquisitionYear('');
        setLicenseValid('');
    }

    function clearAnnuityData() {

    }

    const addJudgeLicense = () => {
        let _affiliate = { ...affiliate };
        let license = { classe: licenseClass, registrationId: licenseRegistrationId, aquisitionYear: licenseAquisitionYear, valid: licenseValid };
        console.log(JSON.stringify(_affiliate.judgeLicenses));
        _affiliate.judgeLicenses = _affiliate.judgeLicenses.concat(license);
        setAffiliate(_affiliate);
        console.log(JSON.stringify(_affiliate.judgeLicenses));
        console.log(_affiliate);

        //     postDataGen(license);

        toast.current.show({ severity: 'success', summary: 'Successful', detail: t('msg.jkaLicenseAdd'), life: 3000 });
        license = null;
        clearLicenseData();
        setJudgeLicenseDialog(false);
    }

    const addInstructorLicense = () => {
        let _affiliate = { ...affiliate };
        let license = { classe: licenseClass, registrationId: licenseRegistrationId, aquisitionYear: licenseAquisitionYear, valid: licenseValid };
        _affiliate.instructorLicenses = _affiliate.instructorLicenses.concat(license);
        setAffiliate(_affiliate);
        console.log(_affiliate);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: t('msg.jkaLicenseAdd'), life: 3000 });
        setInstructorLicenseDialog(false);

    }

    const addDanExam = () => {
        //flvs deleteDanExam
        let _affiliate = { ...affiliate };
        let level = danExamDanId + " DAN";
        let danExam = { record: danExamRecord, date: danExamRecordDate, danId: danExamDanId };
        _affiliate.danExams = _affiliate.danExams.concat(danExam);
        _affiliate.grade = { id: danExamDanId, level: level, belt: 'Faixa Preta' }
        setSelectedGrade({ "id": danExamDanId, "level": level, "belt": 'Faixa Preta' });
        _affiliate.genericGrade = level;
        setAffiliate(_affiliate);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: t('msg.jkaDanExamAdd'), life: 3000 });
        setDanExamDialog(false);
    }

    const addExaminerLicense = () => {
        let _affiliate = { ...affiliate };
        let license = { classe: licenseClass, registrationId: licenseRegistrationId, aquisitionYear: licenseAquisitionYear, valid: licenseValid };
        _affiliate.examinerLicenses = _affiliate.examinerLicenses.concat(license);
        setAffiliate(_affiliate);
        console.log(_affiliate);

        toast.current.show({ severity: 'success', summary: 'Successful', detail: t('msg.jkaLicenseAdd'), life: 3000 });
        setExaminerLicenseDialog(false);

    }

    const addAnnuity = () => {
        let _affiliate = { ...affiliate };
        let annuity = { year: annuityYear, paymentDate: paymentDate, jkabrCardDate: jkabrCardDate, value: value };
        _affiliate.affiliateAnnuities = _affiliate.affiliateAnnuities.concat(annuity);
        setAffiliate(_affiliate);
        console.log(_affiliate);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: t('msg.jkaAffiliateAnnuityAdd'), life: 3000 });
        setAnnuityDialog(false);
    }

    const insertAnnuityDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideInsertAnnuityDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={addAnnuity} />
        </React.Fragment>
    );

    const editAnnuityDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideEditAnnuityDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={updateAnnuity} />
        </React.Fragment>
    );

    const insertExaminerLicenseDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideInsertExaminerLicenseDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={addExaminerLicense} />
        </React.Fragment>
    );

    const editExaminerLicenseDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideEditExaminerLicenseDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={updateExaminerLicense} />
        </React.Fragment>
    );

    const insertDanExamDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideInsertDanExamDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={addDanExam} />
        </React.Fragment>
    );

    const editDanExamDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideEditDanExamDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={updateDanExam} />
        </React.Fragment>
    );


    const editJudgeLicenseDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideEditJudgeLicenseDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={updateJudgeLicense} />
        </React.Fragment>
    );

    const insertInstructorLicenseDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideInsertInstructorLicenseDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={addInstructorLicense} />
        </React.Fragment>
    );

    const editInstructorLicenseDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideEditInstructorLicenseDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={updateInstructorLicense} />
        </React.Fragment>
    );



    const insertJudgeLicenseDialogFooter = (
        <React.Fragment>
            <Button label="Nao" icon="pi pi-times" className="p-button-text" onClick={hideInsertJudgeLicenseDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={addJudgeLicense} />
        </React.Fragment>
    );


     function flvs (licenses) {
         alert (JSON.stringify(licenses))
     }
    return (
        <div className="datatable-crud-demo surface-card p-4 border-round shadow-2">
            <Toast ref={toast} />
            <div className="text-3xl text-800 font-bold mb-4">{t('msg.jkaInstructors')}</div>
            <DataTable ref={dt} value={affiliates} selection={selectedAffiliates} onSelectionChange={(e) => setSelectedAffiliates(e.value)}
                dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate={t('currentPageReportTemplateInstructors')}
                globalFilter={globalFilter} header={header} responsiveLayout="scroll">
         
                <Column field="name" header={t('msg.jkaName')} sortable style={{ minWidth: '16rem' }}></Column>
                <Column field="state.name" header={t('msg.jkaState')} sortable style={{ minWidth: '5rem' }}></Column>
                <Column field="gym.name" header={t('msg.jkaGym')} sortable style={{ minWidth: '20rem' }}></Column>
                <Column field={(rowData) => rowData.instructorLicenses[0]?.classe}  header={t('msg.jkaClass')}  sortable style={{ minWidth: '5rem' }}></Column>
                <Column field="grade.level" header={t('msg.jkaGrade')} sortable style={{ minWidth: '5rem' }}></Column>

                <Column field="status" header={t('msg.jkaAnnuity')} body={statusBodyTemplate} sortable style={{ minWidth: '5rem' }}></Column>
                <Column field="active" header={t('msg.jkaActive')} body={activeBodyTemplate} sortable style={{ minWidth: '5rem' }}></Column>

                <Column field="contacts.mobile1" header={t('msg.jkaMobile')} sortable style={{ minWidth: '5rem' }}
                    body={(row) => phoneBodyTemplate(row.contacts?.mobile1)}></Column>
                <Column field="contacts.phone1" header={t('msg.jkaPhone')} sortable style={{ minWidth: '5rem' }}
                    body={(row) => phoneBodyTemplate(row.contacts?.phone1)}></Column>
                <Column field="affiliateAddress.street" header={t('msg.jkaStreetAddress')} sortable style={{ minWidth: '16rem' }}></Column>
                <Column field="affiliateAddress.streetNumber" header={t('msg.jkaStreetAddressNumber')} sortable style={{ minWidth: '5rem' }}></Column>

                <Column field="birthDate" header={t('msg.jkaBirthDate')} sortable style={{ minWidth: '5rem' }}></Column>
            </DataTable>

            <Dialog visible={affiliateDialog} breakpoints={{ '1024px': '90vw', '640px': '120vw' }} style={{ width: '65vw' }} header="Dados do associado" modal className="p-fluid" footer={affiliateDialogFooter} onHide={hideDialog}>
                {affiliate.image && <img src={`demo/images/product/${affiliate.image}`} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={affiliate.image} className="block mt-0 mx-auto mb-5 w-20rem shadow-2" />}

                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Dados básicos"  >

                        <div className="field">
                            <Fieldset>
                                <div className="formgrid grid">
                                    <div className="field input text col-10">
                                        <label htmlFor="name">{t('msg.jkaName')}</label>
                                        <InputText id="name" value={affiliate.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.name })} />
                                        {submitted && !affiliate.name && <small className="p-error">Name is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="rg">{t('msg.jkaDoc')}</label>
                                        <InputText id="rg" value={affiliate.rg} onChange={(e) => onInputChange(e, 'rg')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.rg })} />
                                        {submitted && !affiliate.rg && <small className="p-error">RG is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="cpf">{t('msg.jkaDocId')}</label>
                                        <InputText id="cpf" value={affiliate.cpf} onChange={(e) => onInputChange(e, 'cpf')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.cpf })} />
                                        {submitted && !affiliate.cpf && <small className="p-error">CPF is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="birthDate">{t('msg.jkaBirthDate')}</label>
                                        <InputText id="birthDate" value={affiliate.birthDate} onChange={(e) => onInputChange(e, 'birthDate')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.birthDate })} />
                                        {submitted && !affiliate.birthDate && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="occupation">{t('msg.jkaOccupation')}</label>
                                        <InputText id="occupation" value={affiliate.occupation} onChange={(e) => onInputChange(e, 'occupation')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.occupation })} />
                                        {submitted && !affiliate.occupation && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                </div >
                            </Fieldset>
                        </div>

                        <div className="field">
                            <Fieldset>
                                <div className="formgrid grid jka">
                                    <div className="field dropdown col-5">
                                        <label htmlFor="gymid">{t('msg.jkaGym')}</label>
                                        <Dropdown optionLabel="name" value={selectedDojo}
                                            options={dojos} onChange={onDojoChange} placeholder="Select a Dojo" />
                                    </div>
                                    <div className="field dropdown col-3">
                                        <label htmlFor="gradesid">{t('msg.jkaGrade')}</label>
                                        <Dropdown optionLabel="level" value={selectedGrade} options={grades} onChange={handleChange} placeholder="Select a Dan" />
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="date">{t('msg.jkaDate')}</label>
                                        <InputText id="date" value={affiliate.date} onChange={(e) => onInputChange(e, 'date')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.date })} />
                                        {submitted && !affiliate.date && <small className="p-error">Date is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="jkaId">{t('msg.jkaIdBR')}</label>
                                        <InputMask id="jkaId" mask="aa-99999" value={affiliate.jkaId} placeholder="FL-99999" onChange={(e) => onInputChange(e, 'jkaId')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.jkaId })} ></InputMask>
                                        {submitted && !affiliate.jkaId && <small className="p-error">JKA ID number is required.</small>}
                                    </div>

                                    <div className="field input text col-3">
                                        <label htmlFor="jkaRegister">{t('msg.jkaIdBRNumber')}</label>
                                        <InputMask id="jkaRegister" mask="aaaaa99999-aa-a" value={affiliate.jkaRegister} placeholder="JKABR99999-AA-A" onChange={(e) => onInputChange(e, 'jkaRegister')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.jkaRegister })} ></InputMask>
                                        {submitted && !affiliate.jkaRegister && <small className="p-error">JKA BR number is required.</small>}
                                    </div>

                                    <div className="field input text col-2">
                                        <label htmlFor="passport">{t('msg.jkaPassport')}</label>
                                        <InputText id="passport" value={affiliate.passport} onChange={(e) => onInputChange(e, 'passport')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.passport })} />
                                        {submitted && !affiliate.passport && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="jkaJpId">{t('msg.jkaJpId')}</label>
                                        <InputMask id="jkaJpId" mask="999999999" value={affiliate.jkaJpId} placeholder="999999999" onChange={(e) => onInputChange(e, 'jkaJpId')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.jkaJpId })} />

                                        {submitted && !affiliate.jkajpNumber && <small className="p-error">birthDate is required.</small>}
                                    </div>

                                    <div className="field input text col-3">
                                        <label htmlFor="jkaJpRecord">{t('msg.jkaJpRecord')}</label>
                                        <InputMask id="jkaJpRecord" mask="999999999" value={affiliate.jkaJpRecord} placeholder="999999999" onChange={(e) => onInputChange(e, 'jkaJpRecord')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.jkaJpId })} />

                                        {submitted && !affiliate.jkajpNumber && <small className="p-error">birthDate is required.</small>}
                                    </div>


                                    <div className="field dropdown col-2">
                                        <label htmlFor="jkaState"> {t('msg.jkaState')} </label>
                                        <Dropdown value={selectedState} options={states} onChange={onStateChange}
                                            optionLabel="name" />
                                    </div>

                                    <div className="field dropdown col-2">
                                        <label htmlFor="status">{t('msg.jkaAnnuity')}</label>
                                        <Dropdown value={selectedPaid} options={statusPayment} onChange={onPaidChange}
                                            optionLabel="name" />
                                    </div>
                                    <div className="field dropdown col-2">
                                        <label htmlFor="active">{t('msg.jkaActive')}</label>
                                        <Dropdown value={selectedActive} options={statusActive} onChange={onActiveChange}
                                            optionLabel="name" />
                                    </div>
                                </div >
                            </Fieldset>
                        </div>

                        <div className="field">
                            <Fieldset>
                                <div className="formgrid grid contacts">
                                    <div className="field input text col-3">
                                        <label htmlFor="email1">{t('msg.jkaEmail')}</label>
                                        <InputText id="contacts.email1" value={affiliate.contacts.email1} onChange={(e) => onInputChange(e, 'contacts.email1')} />
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="email2">{t('msg.jkaEmail')}</label>
                                        <InputText id="contacts.email2" value={affiliate.contacts.email2} onChange={(e) => onInputChange(e, 'contacts.email2')} />
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="mobile1">Celular</label>
                                        <InputMask id="contacts.mobile1" mask="(99)99999-9999" value={affiliate.contacts.mobile1} placeholder="(99)99999-9999" onChange={(e) => onInputChange(e, 'contacts.mobile1')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.contacts.mobile1 })} ></InputMask>
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="mobile2">Celular</label>
                                        <InputMask id="contacts.mobile2" mask="(99)99999-9999" value={affiliate.contacts.mobile2} placeholder="(99)99999-9999" onChange={(e) => onInputChange(e, 'contacts.mobile2')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.contacts.mobile2 })} ></InputMask>
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="phone1">Telefone 1 </label>
                                        <InputMask id="contacts.phone1" mask="(99)9999-9999" value={affiliate.contacts.phone1} placeholder="(99)9999-9999" onChange={(e) => onInputChange(e, 'contacts.phone1')}></InputMask>
                                        {submitted && !affiliate.contacts.phone1 && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="phone2">Telefone 2 </label>
                                        <InputMask id="contacts.phone2" mask="(99)9999-9999" value={affiliate.contacts.phone2} placeholder="(99)9999-9999" onChange={(e) => onInputChange(e, 'contacts.phone2')}></InputMask>
                                        {submitted && !affiliate.contacts.phone2 && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="name">Instagram </label>
                                        <InputText id="socialMedia.instagramId" value={affiliate.socialMedia.instagramId} onChange={(e) => onInputChange(e, 'socialMedia.instagramId')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.socialMedia.instagramId })} />
                                        {submitted && !affiliate.socialMedia.instagramId && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="name">Facebook</label>
                                        <InputText id="socialMedia.facebookId" value={affiliate.socialMedia.facebookId} onChange={(e) => onInputChange(e, 'socialMedia.facebookId')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.socialMedia.facebookId })} />
                                        {submitted && !affiliate.socialMedia.facebookId && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="name">Twitter </label>
                                        <InputText id="socialMedia.twitterId" value={affiliate.socialMedia.twitterId} onChange={(e) => onInputChange(e, 'socialMedia.twitterId')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.socialMedia.twitterId })} />
                                        {submitted && !affiliate.socialMedia.twitterId && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="name">Tiktok </label>
                                        <InputText id="socialMedia.tiktokId" value={affiliate.socialMedia.tiktokId} onChange={(e) => onInputChange(e, 'socialMedia.tiktokId')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.socialMedia.tiktokId })} />
                                        {submitted && !affiliate.socialMedia.tiktokId && <small className="p-error">tiktokId is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="site">Site </label>
                                        <InputText id="socialMedia.site" value={affiliate.socialMedia.site} onChange={(e) => onInputChange(e, 'socialMedia.site')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.socialMedia.site })} />
                                        {submitted && !affiliate.socialMedia.site && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                </div>
                            </Fieldset>
                        </div>

                        <div className="field">
                            <Fieldset>
                                <div className="formgrid grid address">
                                    <div className="field input text col-3">
                                        <label htmlFor="street">Logradouro </label>
                                        <InputText id="affiliateAddress.street" value={affiliate.affiliateAddress.street} onChange={(e) => onInputChange(e, 'affiliateAddress.street')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.affiliateAddress.street })} />
                                        {submitted && !affiliate.affiliateAddress.street && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-1">
                                        <label htmlFor="streetNumber">Numero </label>
                                        <InputNumber id="affiliateAddress.streetNumber" value={affiliate.affiliateAddress.streetNumber} onValueChange={(e) => setStreetNumber(e.value)} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.affiliateAddress.streetNumber })} />
                                        {submitted && !affiliate.affiliateAddress.streetNumber && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="complement">Complemento</label>
                                        <InputText id="affiliateAddress.addressComplement" value={affiliate.affiliateAddress.addressComplement} onChange={(e) => onInputChange(e, 'affiliateAddress.addressComplement')} />

                                    </div>
                                    <div className="field input text col-3">
                                        <label htmlFor="neighborhood">Bairro </label>
                                        <InputText id="affiliateAddress.neighborhood" value={affiliate.affiliateAddress.neighborhood} onChange={(e) => onInputChange(e, 'affiliateAddress.neighborhood')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.affiliateAddress.neighborhood })} />
                                        {submitted && !affiliate.affiliateAddress.neighborhood && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-2">
                                        <label htmlFor="zipCode">CEP </label>
                                        <InputText id="affiliateAddress.zipCode" value={affiliate.affiliateAddress.zipCode} onChange={(e) => onInputChange(e, 'affiliateAddress.zipCode')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.affiliateAddress.zipCode })} />
                                        {submitted && !affiliate.affiliateAddress.zipCode && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-2">
                                        <label htmlFor="city">Cidade </label>
                                        <InputText id="affiliateAddress.city" value={affiliate.affiliateAddress.city} onChange={(e) => onInputChange(e, 'affiliateAddress.city')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.affiliateAddress.city })} />
                                        {submitted && !affiliate.affiliateAddress.city && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                    <div className="field input text col-1">
                                        <label htmlFor="state">Estado</label>
                                        <InputText id="affiliateAddress.state" value={affiliate.affiliateAddress.state} onChange={(e) => onInputChange(e, 'affiliateAddress.state')} required autoFocus className={classNames({ 'p-invalid': submitted && !affiliate.affiliateAddress.state })} />
                                        {submitted && !affiliate.affiliateAddress.state && <small className="p-error">birthDate is required.</small>}
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </TabPanel>


                    <TabPanel header={t('msg.jkaAffiliateAnnuities')}>
                        <p></p>
                        <label htmlFor="name">{affiliate.name}</label>
                        <p></p>
                        <DataTable value={affiliate.affiliateAnnuities} responsiveLayout="scroll">
                            <Column field="year" header={t('msg.jkaYear')} sortable style={{ minWidth: '2rem' }} ></Column>
                            <Column field="paymentDate" header={t('msg.jkaAnnuityPaymentDate')} sortable style={{ minWidth: '2rem' }} ></Column>
                            <Column field="value" header={t('msg.jkaValue')} sortable style={{ minWidth: '2rem' }} ></Column>
                            <Column field="jkabrCardDate" header={t('msg.jkaCardIssueDate')} sortable style={{ minWidth: '2rem' }} ></Column>

                            <Column body={actionAnnuityBodyTemplate} exportable={false} style={{ minWidth: '6rem' }}></Column>
                        </DataTable>
                        <p></p>
                        <Button icon="pi pi-plus-circle" iconPos="right" onClick={showAnnuityDialog} />
                    </TabPanel>

                    <TabPanel header={t('msg.jkaNote')}>
                        <p></p>
                        <label htmlFor="name">{affiliate.name}</label>
                        <p></p>
                        <label htmlFor="note">{t('msg.jkaNote')}</label>
                        <p></p>
                        <InputText id="note" value={affiliate.note} onChange={(e) => onInputChange(e, 'note')} />
                        {submitted && !affiliate.note && <small className="p-error">Name is required.</small>}
                    </TabPanel>

                    <TabPanel header={t('msg.jkaDanExams')}>
                        <p></p>
                        <label htmlFor="name">{affiliate.name}</label>
                        <p></p>
                        <DataTable value={affiliate.danExams} responsiveLayout="scroll">
                            <Column field="danId" header={t('msg.jkaDan')} sortable style={{ minWidth: '1rem' }} ></Column>
                            <Column field="date" header={t('msg.jkaExamDate')} sortable style={{ minWidth: '2rem' }} > </Column>
                            <Column field="record" header={t('msg.jkaLicenseRegistrationId')} sortable style={{ minWidth: '6rem' }} ></Column>
                            <Column body={actionDanExamBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                        </DataTable>
                        <p></p>
                        <Button icon="pi pi-plus-circle" iconPos="right" onClick={showDanExamDialog} />
                    </TabPanel>


                    <TabPanel header={t('msg.jkaInstructorLicense')}>
                        <p></p>
                        <label htmlFor="name">{affiliate.name}</label>
                        <p></p>
                        <DataTable value={affiliate.instructorLicenses} responsiveLayout="scroll">
                            <Column field="classe" header={t('msg.jkaLicenseClass')} sortable style={{ minWidth: '2rem' }} > </Column>
                            <Column field="registrationId" header={t('msg.jkaLicenseRegistrationId')} sortable style={{ minWidth: '6rem' }} ></Column>
                            <Column field="aquisitionDate" header={t('msg.jkaLicenseAquisitionYear')} sortable style={{ minWidth: '1rem' }} ></Column>
                            <Column field="validDate" header={t('msg.jkaLicenseValid')} sortable style={{ minWidth: '5rem' }} ></Column>
                            <Column body={actionInstructorBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>

                        </DataTable>
                        <p></p>

                        <Button icon="pi pi-plus-circle" iconPos="right" onClick={showInstructorLicenseDialog} />

                    </TabPanel>




                    <TabPanel header={t('msg.jkaExaminerLicense')}>
                        <p></p>
                        <label htmlFor="name">{affiliate.name}</label>
                        <p></p>
                        <DataTable value={affiliate.examinerLicenses} responsiveLayout="scroll">
                            <Column field="classe" header={t('msg.jkaLicenseClass')} sortable style={{ minWidth: '2rem' }} > </Column>
                            <Column field="registrationId" header={t('msg.jkaLicenseRegistrationId')} sortable style={{ minWidth: '6rem' }} ></Column>
                            <Column field="aquisitionDate" header={t('msg.jkaLicenseAquisitionYear')} sortable style={{ minWidth: '1rem' }} ></Column>
                            <Column field="validDate" header={t('msg.jkaLicenseValid')} sortable style={{ minWidth: '5rem' }} ></Column>
                            <Column body={actionExaminerBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                        </DataTable>
                        <p></p>
                        <Button icon="pi pi-plus-circle" iconPos="right" onClick={showExaminerLicenseDialog} />
                    </TabPanel>

                    <TabPanel header={t('msg.jkaJudgeLicense')}>
                        <p></p>
                        <label htmlFor="name">{affiliate.name}</label>
                        <p></p>
                        <DataTable value={affiliate.judgeLicenses} responsiveLayout="scroll">
                            <Column field="classe" header={t('msg.jkaLicenseClass')} sortable style={{ minWidth: '2rem' }} > </Column>
                            <Column field="registrationId" header={t('msg.jkaLicenseRegistrationId')} sortable style={{ minWidth: '6rem' }} ></Column>
                            <Column field="aquisitionDate" header={t('msg.jkaLicenseAquisitionYear')} sortable style={{ minWidth: '1rem' }} ></Column>
                            <Column field="validDate" header={t('msg.jkaLicenseValid')} sortable style={{ minWidth: '5rem' }} ></Column>
                            <Column body={actionJudgeBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                        </DataTable>
                        <p></p>
                        <Button icon="pi pi-plus-circle" iconPos="right" onClick={showJudgeLicenseDialog} />
                    </TabPanel>
                </TabView>
            </Dialog>


            <Dialog visible={danExamDialog} style={{ width: '650px' }} header="Inserir exame de dan" modal className="p-fluid" footer={insertDanExamDialogFooter} onHide={hideDanExamDialog}>
                <div className="field">

                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaDan')}</label>
                                <InputMask id="danId" mask="9" placeholder="1" value={danExamDanId} onChange={(e) => setDanExamDanId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="danExamRecordDate">{t('msg.jkaExamDate')}</label>
                                <InputMask id="danExamRecordDate" mask="99/99/9999" placeholder="31/02/2023" value={danExamRecordDate} onChange={(e) => setDanExamRecordDate(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="danExamRecord">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputText id="danExamRecord" value={danExamRecord} onChange={(e) => setDanExamRecord(e.target.value)} />
                            </div>


                        </div>

                    </Fieldset>
                </div>
            </Dialog>



            <Dialog visible={editDanExamDialog} style={{ width: '650px' }} header="Editar exame de dan" modal className="p-fluid" footer={editDanExamDialogFooter} onHide={hideEditDanExamDialog}>
                <div className="field">
                    <Fieldset>

                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaDan')}</label>
                                <InputMask id="danId" mask="9" placeholder="1" value={danExamDanId} onChange={(e) => setDanExamDanId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="danExamRecordDate">{t('msg.jkaExamDate')}</label>
                                <InputMask id="danExamRecordDate" mask="99/99/9999" value={danExamRecordDate} onChange={(e) => setDanExamRecordDate(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="danExamRecord">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputText id="danExamRecord" value={danExamRecord} onChange={(e) => setDanExamRecord(e.target.value)} />
                            </div>


                        </div>

                    </Fieldset>
                </div>
            </Dialog>


            <Dialog visible={instructorLicenseDialog} style={{ width: '650px' }} header="Inserir licença" modal className="p-fluid" footer={insertInstructorLicenseDialogFooter} onHide={hideInstructorLicenseDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaLicenseClass')}</label>
                                <InputMask id="licenseClass" mask="a" placeholder="A" value={licenseClass} onChange={(e) => setLicenseClass(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="licenseRegistrationId">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputMask id="licenseRegistrationId" mask="99a9999" placeholder="99A9999" value={licenseRegistrationId} onChange={(e) => setLicenseRegistrationId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseAquisitionDate">{t('msg.jkaLicenseAquisitionYear')}</label>
                                <InputMask id="licenseAquisitionDate" mask="9999" placeholder="2020" value={licenseAquisitionYear} onChange={(e) => setLicenseAquisitionYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseValidDate">{t('msg.jkaLicenseValid')}</label>
                                <InputMask id="licenseValidDate" mask="99/99/9999" placeholder="31/02/2023" value={licenseValid} onChange={(e) => setLicenseValid(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </Dialog>



            <Dialog visible={editInstructorLicenseDialog} style={{ width: '650px' }} header="Editar licença" modal className="p-fluid" footer={editInstructorLicenseDialogFooter} onHide={hideEditInstructorLicenseDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaLicenseClass')}</label>
                                <InputMask id="licenseClass" mask="a" placeholder="A" value={licenseClass} onChange={(e) => setLicenseClass(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="licenseRegistrationId">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputMask id="licenseRegistrationId" mask="99a9999" placeholder="99A9999" value={licenseRegistrationId} onChange={(e) => setLicenseRegistrationId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseAquisitionDate">{t('msg.jkaLicenseAquisitionYear')}</label>
                                <InputMask id="licenseAquisitionDate" mask="9999" placeholder="2020" value={licenseAquisitionYear} onChange={(e) => setLicenseAquisitionYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseValidDade">{t('msg.jkaLicenseValid')}</label>
                                <InputMask id="licenseValidDate" mask="99/99/9999" placeholder="31/02/2023" value={licenseValid} onChange={(e) => setLicenseValid(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </Dialog>

            <Dialog visible={examinerLicenseDialog} style={{ width: '650px' }} header="Inserir licença" modal className="p-fluid" footer={insertExaminerLicenseDialogFooter} onHide={hideExaminerLicenseDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaLicenseClass')}</label>
                                <InputMask id="licenseClass" mask="a" placeholder="B" value={licenseClass} onChange={(e) => setLicenseClass(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="licenseRegistrationId">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputMask id="licenseRegistrationId" mask="99a9999" placeholder="99A9999" value={licenseRegistrationId} onChange={(e) => setLicenseRegistrationId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseAquisitionDate">{t('msg.jkaLicenseAquisitionYear')}</label>
                                <InputMask id="licenseAquisitionDate" mask="9999" placeholder="2020" value={licenseAquisitionYear} onChange={(e) => setLicenseAquisitionYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseValid">{t('msg.jkaLicenseValid')}</label>
                                <InputText id="licenseValid" value={licenseValid} onChange={(e) => setLicenseValid(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </Dialog>

            <Dialog visible={editExaminerLicenseDialog} style={{ width: '650px' }} header="Editar licença de examinador" modal className="p-fluid" footer={editExaminerLicenseDialogFooter} onHide={hideEditExaminerLicenseDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaLicenseClass')}</label>
                                <InputMask id="licenseClass" mask="a" placeholder="B" value={licenseClass} onChange={(e) => setLicenseClass(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="licenseRegistrationId">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputMask id="licenseRegistrationId" mask="99a9999" placeholder="99A9999" value={licenseRegistrationId} onChange={(e) => setLicenseRegistrationId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseAquisitionYear">{t('msg.jkaLicenseAquisitionYear')}</label>
                                <InputMask id="licenseAquisitionYear" mask="9999" placeholder="2020" value={licenseAquisitionYear} onChange={(e) => setLicenseAquisitionYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseValid">{t('msg.jkaLicenseValid')}</label>
                                <InputText id="licenseValid" value={licenseValid} onChange={(e) => setLicenseValid(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </Dialog>



            <Dialog visible={annuityDialog} style={{ width: '720px' }} header={t('msg.jkaAddAnnuity')} modal className="p-fluid" footer={insertAnnuityDialogFooter} onHide={hideAnnuityDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaYear')}</label>
                                <InputMask id="annuityYear" mask="9999" placeholder="2002" value={annuityYear} onChange={(e) => setAnnuityYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="paymentDate">{t('msg.jkaAnnuityPaymentDate')}</label>
                                <InputMask id="paymentDate" mask="99/99/9999" placeholder="31/01/2023" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                            </div>
                            <div className="field input text col-2">
                                <label htmlFor="value">{t('msg.jkaValue')}</label>
                                <InputMask id="value" mask="9999" placeholder="2020" value={value} onChange={(e) => setValue(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="jkabrCardDate">{t('msg.jkaCardIssueDate')}</label>
                                <InputMask id="jkabrCardDate" mask="99/99/9999" placeholder="31/02/2023" value={jkabrCardDate} onChange={(e) => setJkabrCardDate(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </Dialog>


            <Dialog visible={editAnnuityDialog} style={{ width: '720px' }} header={t('msg.jkaEditAnnuity')} modal className="p-fluid" footer={editAnnuityDialogFooter} onHide={hideEditAnnuityDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaYear')}</label>
                                <InputMask id="annuityYear" mask="9999" placeholder="2002" value={annuityYear} onChange={(e) => setAnnuityYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="paymentDate">{t('msg.jkaAnnuityPaymentDate')}</label>
                                <InputMask id="paymentDate" mask="99/99/9999" placeholder="31/01/2023" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                            </div>
                            <div className="field input text col-2">
                                <label htmlFor="value">{t('msg.jkaValue')}</label>
                                <InputMask id="value" mask="99" placeholder="20" value={value} onChange={(e) => setValue(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="jkabrCardDate">{t('msg.jkaCardIssueDate')}</label>
                                <InputMask id="jkabrCardDate" mask="99/99/9999" placeholder="31/02/2023" value={jkabrCardDate} onChange={(e) => setJkabrCardDate(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </Dialog>

            <Dialog visible={judgeLicenseDialog} style={{ width: '650px' }} header="Inserir licença" modal className="p-fluid" footer={insertJudgeLicenseDialogFooter} onHide={hideJudgeLicenseDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaLicenseClass')}</label>
                                <InputMask id="licenseClass" mask="a" placeholder="C" value={licenseClass} onChange={(e) => setLicenseClass(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="licenseRegistrationId">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputMask id="licenseRegistrationId" mask="99a9999" placeholder="99A9999" value={licenseRegistrationId} onChange={(e) => setLicenseRegistrationId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseAquisitionYear">{t('msg.jkaLicenseAquisitionYear')}</label>
                                <InputMask id="licenseAquisitionYear" mask="9999" placeholder="2020" value={licenseAquisitionYear} onChange={(e) => setLicenseAquisitionYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseValid">{t('msg.jkaLicenseValid')}</label>
                                <InputMask id="licenseValid" mask="99/99/9999" placeholder="31/02/2023" value={licenseValid} onChange={(e) => setLicenseValid(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>

                </div>
            </Dialog>


            <Dialog visible={editJudgeLicenseDialog} style={{ width: '650px' }} header="Editar licença de arbitragem" modal className="p-fluid" footer={editJudgeLicenseDialogFooter} onHide={hideEditJudgeLicenseDialog}>
                <div className="field">
                    <Fieldset>
                        <div className="formgrid grid license">
                            <div className="field input text col-2">
                                <label htmlFor="class">{t('msg.jkaLicenseClass')}</label>
                                <InputMask id="licenseClass" mask="a" placeholder="C" value={licenseClass} onChange={(e) => setLicenseClass(e.target.value)} />
                            </div>
                            <div className="field input text col-4">
                                <label htmlFor="licenseRegistrationId">{t('msg.jkaLicenseRegistrationId')}</label>
                                <InputMask id="licenseRegistrationId" mask="99a9999" placeholder="99A9999" value={licenseRegistrationId} onChange={(e) => setLicenseRegistrationId(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseAquisitionYear">{t('msg.jkaLicenseAquisitionYear')}</label>
                                <InputMask id="licenseAquisitionYear" mask="9999" placeholder="2020" value={licenseAquisitionYear} onChange={(e) => setLicenseAquisitionYear(e.target.value)} />
                            </div>
                            <div className="field input text col-3">
                                <label htmlFor="licenseValid">{t('msg.jkaLicenseValid')}</label>
                                <InputMask id="licenseValid" mask="99/99/9999" placeholder="31/02/2023" value={licenseValid} onChange={(e) => setLicenseValid(e.target.value)} />
                            </div>
                        </div>
                    </Fieldset>
                </div>
            </Dialog>



            <Dialog visible={deleteAffiliateDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteAffiliateDialogFooter} onHide={hideDeleteAffiliateDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {affiliate && <span>Are you sure you want to delete <b>{affiliate.name}</b>?</span>}
                </div>
            </Dialog>

            <Dialog visible={deleteAffiliatesDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteAffiliatesDialogFooter} onHide={hideDeleteAffiliatesDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {affiliate && <span>Are you sure you want to delete the selected products?</span>}
                </div>
            </Dialog>


            <Dialog visible={deleteDanExamDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteDanExamDialogFooter} onHide={hideDeleteDanExamDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {affiliate && <span>Are you sure you want to delete exam </span>}
                </div>
            </Dialog>

            <Dialog visible={deleteJudgeLicenseDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteJudgeLicenseDialogFooter} onHide={hideDeleteJudgeLicenseDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {affiliate && <span>Are you sure you want to delete judge license </span>}
                </div>
            </Dialog>


            <Dialog visible={deleteInstructorLicenseDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteInstructorLicenseDialogFooter} onHide={hideDeleteInstructorLicenseDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {affiliate && <span>Are you sure you want to delete instructor license </span>}
                </div>
            </Dialog>

            <Dialog visible={deleteExaminerLicenseDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteExaminerLicenseDialogFooter} onHide={hideDeleteExaminerLicenseDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {affiliate && <span>Are you sure you want to delete examiner license </span>}
                </div>
            </Dialog>



            <Dialog visible={deleteAnnuityDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteAnnuityDialogFooter} onHide={hideDeleteAnnuityDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {affiliate && <span>Are you sure you want to delete annuity </span>}
                </div>
            </Dialog>

        </div>



    );
}

export default Instructors;